import AdvanteIcons from "../AdvanteIcons";
import LayoutSoftware from "../../images/software-layout.webp"

const Header = () => {
  return (
    <section className="software-design-header">
      <div className="software-layout containerFull">
        <div className="software-layout-container">
          <img 
            src={ LayoutSoftware }
            alt="Layout Software"
            loading="lazy"
          />
        </div>
      </div>
      <div className="containerFull">
        <div className="software-design-label">
          <div className="software-design-icon">
            <AdvanteIcons type="IcoSoftwareProductDesign" fill="var(--soft-beige)" />
          </div>
          <h2>Product Design &amp; UX</h2>
        </div>

        <div className="software-design-headline">
          <h1>Improving <span className="h1-thin">product flows</span>, <span className="h1-box">forms</span>, <br /><span className="h1-vision">dashboards</span> <span className="h1-box">and</span> <span className="h1-thin">user experiences</span>.</h1>
        </div>
      </div>
    </section>
  );
};

export default Header;
